import React from 'react';

import styled from 'styled-components';

// constants
import aampeTheme from '../../../constants/aampeTheme';

// components
import TextWithInfoTooltip from './TextWithInfoTooltip';

interface LabelWithInfoProps {
    text: string;
    description?: React.ReactNode | string;
    isRequired?: boolean;
}

const StyledTextWithInfoTooltip: React.FC<
    React.PropsWithChildren<LabelWithInfoProps>
> = ({ text, description, isRequired }) => {
    return (
        <StyledTextWithInfo
            tooltipPlacement="right"
            text={text}
            description={description}
            isRequired={isRequired}
        />
    );
};

const StyledTextWithInfo = styled(TextWithInfoTooltip)({
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: '20px',
    display: 'flex',
    color: aampeTheme.colors.gray800,
    justifyContent: 'start',
    alignItems: 'center',
    marginBottom: aampeTheme.spacing(1),
});

export default StyledTextWithInfoTooltip;
